<template>
    <div class="legend-content">
        <div style="position: relative;">
            <div class="name clearfix">
                <span class="left">
                    图例
                </span>
                <span @click="legendShow()" class="legend-icon right">
                    <i :class="legendType ? 'iconfont icon-shouqi1': 'iconfont icon-zhankai'"></i>
                </span>
            </div>
            <div  v-show="legendType">
                <ul>
                    <li class="legend-li">
                    <span class="legend-value">
                      <img :src="img" alt=""/>
                    </span>
                        <span class="legend-label" title="公告地块">公告地块</span>
                    </li>

                    <li v-for="(item, index) in list" :key="index" class="legend-li ">
                        <span class="legend-value">
                          <i class="iconfont" :class="item.icon" style="position:absolute;cursor: pointer;color:#fff;font-size:15px;left: 50%;transform: translateX(-50%);top:4px;"></i>
                          <i style="font-size: 28px;" :style="{'color': item.color}" class="iconfont icon-dingdian"></i>
                        </span>
                        <span class="legend-label " :title="item.title" style="position:relative;top:2px;">{{ item.title }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import announcement from '@/assets/images/mapView/announcement.png'
// import industrial from '@/assets/images/mapView/industrial.png'
// import business from '@/assets/images/mapView/business.png'
// import residential from '@/assets/images/mapView/residential.png'
// import other from '@/assets/images/mapView/other.png'
export default {
  data() {
    return {
      img: announcement,
      list: [
        {
          title: '工业用地',
          icon: 'iconfont icon-gongye',
          color: '#E18D34'

        }, {
          title: '商业用地',
          icon: 'iconfont icon-shangye',
          color: '#32B9EE'
        }, {
          title: '住宅用地',
          icon: 'iconfont icon-zhuzhai',
          color: '#20CD86'
        }, {
          title: '其他用地',
          icon: 'iconfont icon-qita1',
          color: '#9E5CE8'
        }],
      legendType: true
    }
  },
  mounted() {
    //
  },
  methods: {
    legendShow() {
      this.legendType = !this.legendType
    }
  }
}
</script>

<style lang="scss" scope>
    .legend-content {
        overflow: auto;
        z-index: 1199;
        position: absolute;
        right: 10px;
        width: 120px;
        bottom: 110px;
        border-radius: 5px;
        border: 1px solid #ccc;
        background-color: white;
        .name {
            line-height: 32px;
            text-align: center;
            font-size: 16px;
            color: #333;
            background: #F6F5F4;
            padding: 0px 10px;
            .legend-icon{
                cursor: pointer;
            }
        }
        .legend-li {
            background: rgba(255,255,255,0.90);
            box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.25);
            text-align: center;
            padding: 5px 0px;
            &:nth-child(1){
                .legend-value {
                    text-align: left;
                }
            }
            .legend-value {
                vertical-align: middle;
                width: 28px;
                display: inline-block;
                border-radius: 98%;
                transform: translateX(-20%);
            }
            .legend-label {
                font-size: 14px;
                color: #333333;
                width: 62px;
            }
             .iconfont{
                font-size: 18px;
                color:white;
            }
        }
    }
</style>
